import { color } from "framer-motion";
import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// CATEGORIAS
const categories = {
  Backend: [
    { name: "C#", img: "https://img.shields.io/badge/C%23-239120?style=for-the-badge&logo=c-sharp&logoColor=white" },
    { name: ".NET", img: "https://img.shields.io/badge/.NET-512BD4?style=for-the-badge&logo=dotnet&logoColor=white" },
    { name: "PHP", img: "https://img.shields.io/badge/PHP-777BB4?style=for-the-badge&logo=php&logoColor=white" },
    { name: "Laravel", img: "https://img.shields.io/badge/Laravel-FF2D20?style=for-the-badge&logo=laravel&logoColor=white" },
    { name: "NodeJS", img: "https://img.shields.io/badge/Node.js-339933?style=for-the-badge&logo=node.js&logoColor=white" },
    { name: "Python", img: "https://img.shields.io/badge/Python-3776AB?style=for-the-badge&logo=python&logoColor=white" },
    { name: "Go", img: "https://img.shields.io/badge/Go-00ADD8?style=for-the-badge&logo=go&logoColor=white" }
  ],

  Messaging: [
    { name: "RabbitMQ", img: "https://img.shields.io/badge/RabbitMQ-FF6600?style=for-the-badge&logo=rabbitmq&logoColor=white" },
    { name: "Kafka", img: "https://img.shields.io/badge/Kafka-231F20?style=for-the-badge&logo=apachekafka&logoColor=white" }
  ],

  Databases: [
    { name: "SQL Server", img: "https://img.shields.io/badge/SQL%20Server-CC2927?style=for-the-badge&logo=microsoftsqlserver&logoColor=white" },
    { name: "PostgreSQL", img: "https://img.shields.io/badge/PostgreSQL-4169E1?style=for-the-badge&logo=postgresql&logoColor=white" },
    { name: "MySQL", img: "https://img.shields.io/badge/MySQL-4479A1?style=for-the-badge&logo=mysql&logoColor=white" },
    { name: "MongoDB", img: "https://img.shields.io/badge/MongoDB-47A248?style=for-the-badge&logo=mongodb&logoColor=white" },
    { name: "Redis", img: "https://img.shields.io/badge/Redis-DC382D?style=for-the-badge&logo=redis&logoColor=white" },
    { name: "SQLite", img: "https://img.shields.io/badge/SQLite-003B57?style=for-the-badge&logo=sqlite&logoColor=white" },
    { name: "Oracle", img: "https://img.shields.io/badge/Oracle-F80000?style=for-the-badge&logo=oracle&logoColor=white" },
    { name: "CouchDB", img: "https://img.shields.io/badge/CouchDB-E42528?style=for-the-badge&logo=apachecouchdb&logoColor=white" }
  ],

  Frontend: [
    { name: "HTML", img: "https://img.shields.io/badge/HTML5-E34F26?style=for-the-badge&logo=html5&logoColor=white" },
    { name: "CSS", img: "https://img.shields.io/badge/CSS3-1572B6?style=for-the-badge&logo=css3&logoColor=white" },
    { name: "JavaScript", img: "https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=javascript&logoColor=black" },
    { name: "TypeScript", img: "https://img.shields.io/badge/TypeScript-3178C6?style=for-the-badge&logo=typescript&logoColor=white" },
    { name: "jQuery", img: "https://img.shields.io/badge/jQuery-0769AD?style=for-the-badge&logo=jquery&logoColor=white" },
    { name: "Bootstrap", img: "https://img.shields.io/badge/Bootstrap-7952B3?style=for-the-badge&logo=bootstrap&logoColor=white" },
    { name: "React", img: "https://img.shields.io/badge/React-61DAFB?style=for-the-badge&logo=react&logoColor=black" },
    { name: "Angular", img: "https://img.shields.io/badge/Angular-DD0031?style=for-the-badge&logo=angular&logoColor=white" },
    { name: "Vue.js", img: "https://img.shields.io/badge/Vue.js-4FC08D?style=for-the-badge&logo=vuedotjs&logoColor=white" },
    { name: "Single-SPA", img: "https://img.shields.io/badge/Single--SPA-000000?style=for-the-badge&logo=single-spa&logoColor=white" }
  ],

  Observability: [
    { name: "Elasticsearch", img: "https://img.shields.io/badge/Elasticsearch-005571?style=for-the-badge&logo=elasticsearch&logoColor=white" },
    { name: "Kibana", img: "https://img.shields.io/badge/Kibana-005571?style=for-the-badge&logo=kibana&logoColor=white" }
  ],

  DevOps: [
    { name: "Docker", img: "https://img.shields.io/badge/Docker-2496ED?style=for-the-badge&logo=docker&logoColor=white" },
    { name: "Podman", img: "https://img.shields.io/badge/Podman-3333ED?style=for-the-badge&logo=podman&logoColor=white" },
    { name: "Kubernetes", img: "https://img.shields.io/badge/Kubernetes-326CE5?style=for-the-badge&logo=kubernetes&logoColor=white" },
    { name: "Terraform", img: "https://img.shields.io/badge/Terraform-7B42BC?style=for-the-badge&logo=terraform&logoColor=white" },
    { name: "Azure", img: "https://img.shields.io/badge/Azure-0078D4?style=for-the-badge&logo=microsoftazure&logoColor=white" },
    { name: "AWS", img: "https://img.shields.io/badge/AWS-FF9900?style=for-the-badge&logo=amazonaws&logoColor=white" },
    { name: "Jenkins", img: "https://img.shields.io/badge/Jenkins-D24939?style=for-the-badge&logo=jenkins&logoColor=white" },
    { name: "Argo CD", img: "https://img.shields.io/badge/Argo%20CD-FE7A16?style=for-the-badge&logo=argo&logoColor=white" }
  ]
};

// ESTILO FIXO PARA PADRONIZAR ALTURA E LARGURA DOS CARDS
const cardStyle = {
  width: "220px",
  height: "110px",
  background: "white",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px"
};

export default function Skills() {
  const [key, setKey] = useState("Backend");

  return (
    <div className="w-full py-4">
      <Tabs
        id="skills-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-4 justify-content-center custom-tabs"
      >
        {Object.keys(categories).map((category) => (
          <Tab eventKey={category} title={category} key={category}>
            
            <div className="mt-4">
              <Carousel
                autoPlay
                infiniteLoop
                interval={2600}
                showThumbs={false}
                showStatus={false}
                showIndicators={false}
                centerMode
                centerSlidePercentage={40}
              >
                {categories[category].map((skill, index) => (
                  <div key={index} className="d-flex justify-content-center p-3">
                    <div style={cardStyle}>
                      <img
                        src={skill.img}
                        alt={skill.name}
                        style={{ maxHeight: "70px", objectFit: "contain" }}
                      />
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>

          </Tab>
        ))}
      </Tabs>
    </div>
  );
}
